import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { SubmittingUserStore } from '../features/application/SubmittingUserStore';

export const useTechnicianContactValidation = () => {
    const { requiresSubmittingUser } = useProviderConfig();
    const { setupData } = SetupDataStore.useStore();
    const { submittingUser } = SubmittingUserStore.useStore();

    if (!requiresSubmittingUser || !submittingUser.firstName) {
        return;
    }

    const missingFields: string[] = [];
    if (!submittingUser.phone) {
        missingFields.push('a phone number');
    }
    if (!submittingUser.email) {
        missingFields.push('an email address');
    }

    if (missingFields.length > 0) {
        const providerName = setupData?.provider ?? 'financing';
        throw new Error(
            `In order to submit a ${providerName} application, you must have ${missingFields.join(' and ')}. Please update your profile.`,
        );
    }
};
